import Container from "./RelationInputWithTable";

export default Container;
